(function() {
    var PDP_INFO = {
        el: {
            $container: null,
            $optPopup: null,
        },
        selector: {
            optPopup: '#pop-opt-visual'
        },
        setProperty: function () {               
            this.el.$optPopup = this.el.$container.find(this.selector.optPopup);
        },
        bindEvents: function () {
            $(window).on('resize', this.handler.resize.bind(this)).triggerHandler('resize');

            // 더보기형 팝업 이벤트
            this.el.$container.on('click', 'button[data-more-card]', this.handler.moreCardHandler.bind(this));
        },
        handler: {
            resize: function () {
                // 옵션 개수 4개이상일때 클래스 추가
                var optRadioArea = this.el.$container.find('.opt-radio-area');

                optRadioArea.each(function(i) {
                    var _self = $(this);
                    var optRadio = _self.find('.opt-radio');
                    var optRadioCnt = optRadio.length;

                    if(optRadioCnt == 4) {
                        _self.addClass('column01');
                    } else if(optRadioCnt > 4) {
                        _self.addClass('column02');
                    } else {
                        return;
                    }
                });
            },
            moreCardHandler: function (e) {
                e.preventDefault;

                var target = $(e.currentTarget);
                var popupSelector = target.data('more-card');

                if (!!popupSelector.length) {
                    var $popupTarget = $('div[data-moreCnt="' + popupSelector + '"]');
                    if (!!$popupTarget.length) $popupTarget.vcModal({opener: target});
                }
            },
        },     
        init: function (el) {
            var self = this;
            this.el.$container = $(el);

            if (!this.el.$container.length > 0) return;

            this.setProperty();
            this.bindEvents();

            this.initOptionalSwiper('.opt-thumb.swiper');

            this.el.$container.find('.ui_selectbox').each(function (idx, el) {
                $(el).on('selectboxinit', function (e) {
                    var $select = $(e.target);

                    self.optionDisabled($select);
                    self.optionPlaceholder($select);
                });
            }); 
        },

        /**
         * 옵션 선택 스와이프 
         * @param {string} selector swiper selector
         */
        initOptionalSwiper: function (selector) {
            var self = this;
            
            this.el.$container.find(selector).each(function (idx, el) {
                new Swiper(el, {
                    preventClicks: true,
                    preventClicksPropagation: true,
                    spaceBetween: 8,
                    observer: true, 
                    observeParents: true,
                    resistance: true,
                    resistanceRatio: 0,
                    slidesPerView: 'auto',
                    slideActiveClass: 'active',
                    navigation: {
                        nextEl: el.nextElementSibling.querySelector('.next'),
                        prevEl: el.nextElementSibling.querySelector('.prev'),
                    }
                });
            })

            // 확대 기능 초기화
            self.initPinchZoom(this.el.$optPopup);  

            // 스와이프 클릭
            $(selector).on('click', '.swiper-slide a', function (e) {
                e.preventDefault();
    
                var target = $(e.currentTarget);
                var swiper = target.closest('.swiper').get(0).swiper;

                if (!swiper) return ;

                var num = parseInt(target.closest('.swiper-slide').attr('aria-label').replace(/ \/ \d+/, '')) || 1;
                var idx = num - 1;
                
                self.openOptionalPopup(target, idx);
            })
        },

        /**
         * 팝업 오픈 함수
         * @param {jQueryElement} opener 팝업 닫기 후 돌아갈 대상
         * @param {number} act 활성화 섭네일 index
         */
        openOptionalPopup: function (opener, act) {
            var $popup = this.el.$optPopup;

            // 클릭 섭네일 정보 토대로 팝업 상태 초기화
            var $popThumbnail = $popup.find('.ui_smooth_scrolltab');
            var $popThumbnailWrap = $popup.find('.pop-thumbnail-list');
            var $popThumbnailLI = $popThumbnailWrap.find('> li');
            var $tempLI = $popThumbnailLI.removeClass('on').eq(0).clone();
            $popThumbnailLI.remove();

            // 타이틀
            var $title = opener.closest('.opt-info').find('.tit-area .tit');
            $popup.find('h1.tit > span').text($title.text());

            // 섭네일 생성
            var $swiper = opener.closest('.swiper');
            if (!!$swiper.length) {
                var swiper = $swiper.get(0).swiper;

                if (!swiper) return;

                $(swiper.slides).not('.swiper-slide-duplicate').each(function (idx, el) {
                    var $img = $(el).find('img')
                    var $source = $tempLI.clone();
                    $source.find('img').attr({
                        src: $img.attr('src'),
                        alt: $img.attr('alt'),
                    });
                    
                    $popThumbnailWrap.append($source);
                });
            }

            // item 변경으로 섭네일 상태 변경
            var smoothScrollTab = $popThumbnail.vcSmoothScrollTab('instance', false);
            if (smoothScrollTab) smoothScrollTab.resetStatus(act);
            
            // 정확한 위치를 위해 팝업 오픈 후 
            $popup.one('modalshown', function (e) {
                // 섭네일 활성화 및 스크롤 이동
                if (smoothScrollTab) smoothScrollTab.activePositionTime(0);
                $popThumbnail.css('opacity', 1);
            });

            $popup.one('modalhidden', function (e) {
                if (smoothScrollTab) smoothScrollTab.resetStatus(0);
                $popThumbnail.css('opacity', 0);
            });

            // 섭네일 클릭 이벤트 발생
            $popThumbnailWrap.find('> li.on > a').trigger('click');

            // 팝업 오픈
            $popup.vcModal({opener: opener});
        },

        /**
         * 확대 초기화
         * @param {jQueryElement} target 확대 element 있는 팝업
         */
        initPinchZoom: function($target) {
            var self = this;

            vcui.require(['ui/pinchZoom'], function () {
                var $popup = $target;

                // console.log('!!!!! initPinchZoom', $popup);
                
                var $pinchZoom = $popup.find('.zoom-area');
                $pinchZoom.vcPinchZoom();
                
                self.addEventProdCtrl($popup);
                self.addEventProdZoom($popup);
                self.prodSlideBtnHide($popup);
            });
        },

        /**
         * 컨트롤러 이벤트
         * @param {jQueryElement} $target 팝업 부모
         */
        addEventProdCtrl: function ($target) {
            var pinchZoom = $target.find('.zoom-area').vcPinchZoom('instance', false);
            var largeImg = $target.find('.item-box').find('img');

            if (!pinchZoom) return;

            // + 버튼
            $target.on('click.pinch-zooom', '.zoom-plus', function (e) {
                e.preventDefault();

                var zoom = pinchZoom.getZoomFactor();
                if(Math.round(zoom) >= 4) zoom = 0;
                pinchZoom.runZoom(zoom+1, true);
            });

            // - 버튼
            $target.on('click.pinch-zooom', 'a.zoom-minus', function (e) {
                e.preventDefault();

                var zoom = pinchZoom.getZoomFactor();
                pinchZoom.runZoom(zoom-1, true);
            });

            // 섭네일 클릭
            $target.on('click.pinch-zoom', '.pop-thumbnail-list a', function (e) {
                e.preventDefault();
                
                var target = $(e.currentTarget);

                var img = target.children('img');
                var imgSrc = img.attr('src');

                target.parent().addClass('on').siblings().removeClass('on');
                largeImg.attr({src: imgSrc});

                pinchZoom.runZoom(1, false);
            });
        },

        /**
         * 이동없이 클릭 시 + 버튼 click event 발생 시켜 확대 기능 추가 구현
         * @param {jQueryElement} $target 팝업 부모
         */
        addEventProdZoom : function ($target) {
            var isDragging = false;
            $target.on(
            'mousedown.pinch-zooom, mousemove.pinch-zooom, mouseup.pinch-zooom',
            '.default > .item.image',
            function (e) {
                switch (e.type) {
                    case 'mousedown' :
                        isDragging = false;
                        break;
                    case 'mousemove' :
                        isDragging = true;
                        break;
                    case 'mouseup' :
                        var wasDragging = isDragging;
                        isDragging = false;
                        if (!wasDragging) {
                            $target.find('div.zoom-btn-area a.zoom-plus').trigger('click');
                        }
                        break;
                    default :
                }
            });
        },

        /**
         * 섭네일 좌우 버튼 숨김
         * @param {jQueryElement} $target 팝업 부모
         */
        prodSlideBtnHide : function ($target) {
            var thumbList = $target.find('.pop-thumbnail-list');
            var thumbListWrap = thumbList.parent();

            if(thumbList.width() > thumbListWrap.width()) {
                thumbListWrap.siblings('.scroll-controls').hide();
            }
        },

        /**
         * 셀렉트 박스 첫번째 <option> 에 대한 placeholder 기능
         * @param {jQueryElement} $target select 태그
         */
        optionPlaceholder: function ($target) {
            if (!$target.find('option:first-child').is('.placeholder')) return;

            var $listWrap = $target.next('.ui-selectbox-wrap').find('.ui-select-scrollarea');
            
            $listWrap.find('li:first-child').hide();

            $listWrap.on('click', 'a', function (e) {
                var item = $(this);
                var idx = item.parent().index();
                if(idx == 0) {
                    item.closest('ul').children('li:first-child').hide();
                } else {
                    item.closest('ul').children('li:first-child').show();
                }
            });
        },

        /**
         * 셀렉트 박스 옵션별 비활성화
         * @param {jQueryElement} $target select 태그
         */
        optionDisabled: function ($target) {
            $target.children('option').each(function() {
                var opt = $(this);
                if(opt.prop('disabled') == true) {
                    var idx = opt.index();
                    opt.parent().siblings('.ui-selectbox-wrap').children('.ui-selectbox-list').children('.ui-select-scrollarea').find('a').eq(idx).addClass('disabled');
                }
            });
        }
    };
    
    $(function () {
        PDP_INFO.init(".pdp-info-area");
    })
})();